import React, { useState } from "react";
import { DropDown, Loader, RadioContainer } from "../commons";
import { Label } from "reactstrap";
import { TimePicker } from "@mui/x-date-pickers";
import Select from "react-select";
import { components } from "react-select";
import { WarningIcon } from "../../assets/images";

type RadioTypes = {
  id: string;
  name: string;
};

type AppProps = {
  radioOptions: RadioTypes[];
  finalClientList: any;
  clientSelected: any;
  finalJobList: any;
  fetching: boolean;
  jobSelected: any;
  startTime: string;
  endTime: string;
  comment: string;
  timeSheetEntryType: string;
  activityCode: any;
  finalActivityCodeData: any;
  setEndTime: any;
  setStartTime: any;
  timeSheetError: any;
  isEdit: string;
  handleSetRadioValue: (value: string) => void;
  handleAddTimeSheetData: () => void;
  handleChange: (data: any, name: string) => void;
  copyData: any;
  timeDifference: string;
  showTimeSheetUserModal?: boolean;
  showTimeSheetUnfilledDate?: boolean;
  handleChangeStatus: () => void;
  sharedJob?: boolean;
  addTimeSheet?: boolean;
  editTimeSheet?: boolean;
  editDateTimesheet?:boolean;
};

const AddEditTimeSheet = ({
  radioOptions,
  timeDifference,
  handleSetRadioValue,
  timeSheetEntryType,
  handleAddTimeSheetData,
  handleChange,
  timeSheetError,
  finalActivityCodeData,
  activityCode,
  finalClientList,
  clientSelected,
  finalJobList,
  jobSelected,
  isEdit,
  startTime,
  setEndTime,
  setStartTime,
  endTime,
  comment,
  copyData,
  fetching,
  showTimeSheetUserModal,
  showTimeSheetUnfilledDate,
  handleChangeStatus,
  sharedJob,
  addTimeSheet,
  editTimeSheet,
  editDateTimesheet
}: AppProps) => {
  const { clientError, jobError, startError, endError, activityError } =
    timeSheetError;

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div>
          <div>{data?.label}</div>
          <div className="inside-card-sub-heading">{data?.description}</div>
        </div>
      </components.Option>
    );
  };

  return (
    <>
      <p className="timesheet-sub-heading">
        {isEdit ? "Edit" : "Add"} Timesheet Entry
      </p>
      {!editDateTimesheet?
          <div
        className="d-flex justify-content-start align-items-center p-1 mt-3 mb-4 warningMessage"
      >
        <>
        <img src={WarningIcon} alt="warning" />
        <span  className="ml-2 warningText">
        Warning: You cannot delete or update timesheet entries older than 10 days.
        </span>
        </>
      </div>
        :""}
      <div className="mt-2 mb-4">
        <RadioContainer
          optionsList={radioOptions}
          handleSetRadioValue={handleSetRadioValue}
          radioValue={timeSheetEntryType}
        />
        {timeSheetEntryType === "billable" ? (
          <>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "8px",
                marginBottom: "15px",
                marginLeft: "-15px",
                marginTop: "14px",
              }}
            >
              <label className="switchs ml-3">
                <input
                  type="checkbox"
                  checked={sharedJob}
                  onChange={() => handleChangeStatus()}
                />
                <span className="sliders rounds"></span>
              </label>
              <span style={{ fontWeight: "500" }}>Show me Shared Jobs</span>
            </div>
            {!sharedJob ? (
              <div className="mt-3 mb-3 w-75">
                <Label>Client</Label>
                <span className="color-red">*</span>
                <DropDown
                  placeholder="Choose Client.."
                  options={finalClientList}
                  handleChange={(e: any) => handleChange(e, "client")}
                  value={clientSelected}
                />
                <div>
                  {!!clientError && (
                    <small className="text-danger">{clientError}</small>
                  )}
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="w-75">
              <Label>Job</Label>
              <span className="color-red">*</span>
              <DropDown
                placeholder="Choose Job.."
                options={finalJobList}
                handleChange={(e: any) => handleChange(e, "job")}
                value={jobSelected}
              />
              <div>
                {!!jobError && (
                  <small className="text-danger">{jobError}</small>
                )}
              </div>
            </div>
          </>
        ) : null}
        <form>
          <div className="d-flex mt-3">
            <div className="mb-3  mr-2">
              <div className="">
                <div></div>
                <TimePicker
                  label="Start Time"
                  value={startTime}
                  sx={{
                    label: { zIndex: 0 },
                  }}
                  onChange={(date: any) => setStartTime(date)}
                />
              </div>
              <div>
                {!!startError && (
                  <small className="text-danger">{startError}</small>
                )}
              </div>
            </div>
            <div className="mb-3 ">
              <div className="">
                <div></div>
                <TimePicker
                  label="End Time"
                  value={endTime}
                  sx={{
                    label: { zIndex: 0 },
                  }}
                  onChange={(date: any) => setEndTime(date)}
                />
              </div>
              <div>
                {!!endError && (
                  <small className="text-danger">{endError}</small>
                )}
              </div>
            </div>

            <div
              className={`timesheet-diff ml-2 ${
                endError || startError ? "mb-5" : "mb-4"
              }`}
            >
              {timeDifference}
            </div>
          </div>

          <div className="form-group mt-3 w-75">
            <label htmlFor="PAN" className={activityCode ? "active" : ""}>
              Activity Code
            </label>
            <span className="color-red">*</span>
            {/* <DropDown
                placeholder="Choose Activity Code.."
                options={finalActivityCodeData}
                handleChange={(e:any)=>handleChange(e,"Activity-code")}
                value={activityCode}
              /> */}
            <Select<any, false>
              inputProps={{ autoComplete: "nope" }}
              placeholder={"Choose Activity Code.."}
              options={finalActivityCodeData}
              value={activityCode}
              components={{ Option }}
              isSearchable={true}
              // onMenuScrollToBottom={(e: any) => checkBottom(e)}
              // onInputChange={(e: string) => {
              //   setLoadCondition(false);
              //   setText(e);
              //   setoffset(0);
              // }}
              onChange={(e: any) => handleChange(e, "Activity-code")}
            />
            <div>
              {!!activityError && (
                <small className="text-danger">{activityError}</small>
              )}
            </div>
          </div>
        </form>
        <form>
          <div className="form-group mt- w-75">
            <label htmlFor="Comment" className={comment ? "active" : ""}>
              Comment
            </label>
            <textarea
              className="form-control"
              name="pan"
              value={comment}
              onChange={(e: any) => handleChange(e, "comments")}
              placeholder="Add your work brief here"
            />
          </div>
        </form>
        {addTimeSheet && !isEdit && (
          <div style={{display:"flex", gap:'20px'}}>

          <button
            className="btn btn-primary mt-4"
            onClick={() => handleAddTimeSheetData()}
            disabled={!editDateTimesheet}
            style={{cursor: editDateTimesheet ? "pointer" : "not-allowed"}} 
          >
            {"+ Add Entry"} 
          </button>
       
          </div>
          
        )}
        {editTimeSheet && isEdit && (
          <button
            className="btn btn-primary mt-4"
            onClick={() => handleAddTimeSheetData()}
          >
            {"Edit Entry"}
          </button>
        )}
      </div>
      {fetching && !showTimeSheetUserModal && !showTimeSheetUnfilledDate && (
        <Loader />
      )}
    </>
  );
};

export default AddEditTimeSheet;
